<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pl-0">
          <h4 class="font-weight-regular primary--text">Estadísticas generales</h4>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-container fluid>
            <v-row justify="space-between" v-if="!loading">

              <!-- Ticket promedio -->
              <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Ticket promedio</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">{{ (clients_reports.avgTicket || 0) | toFixNumber(2) | numberWithComma | prefix('$') }}</h3>
                  </v-col>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- Ventas brutas -->
              <v-col cols="2" class="text-center" style="position: relative">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Ventas brutas</h5>
                  </v-col>
                  <v-col cols="12" md="12">
                    <h3 class="font-weight-regular color-black">{{ ((Number(clients_reports.total) || 0) + (Number(clients_reports.totalDiscount) || 0)) | toFixNumber(2) | numberWithComma | prefix('$') }}</h3>
                  </v-col>
                  <v-btn :to="{
                      name: 'sales-before-tax',
                      query: {
                        dates: dates,
                        period: period
                      }
                    }"
                    absolute
                    right
                    fab
                    small
                    style="right: -5px">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- Descuentos -->
              <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Descuentos</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">{{ (clients_reports.totalDiscount || 0) | toFixNumber(2) | numberWithComma | prefix('$') }}</h3>
                  </v-col>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- Cortesías -->
              <!-- <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Cortesías</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">$0.00</h3>
                  </v-col>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span> -->

              <!-- Ventas Netas -->
              <v-col cols="2" class="text-center" style="position: relative">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Ventas Netas</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">{{ (clients_reports.total || 0) | toFixNumber(2) | numberWithComma | prefix('$') }}</h3>
                  </v-col>
                  <v-btn :to="{
                      name: 'after-tax-sales',
                      query: {
                        dates: dates,
                        period: period
                      }
                    }"
                    absolute
                    right
                    fab
                    small
                    style="right: -5px">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>

            <loader :loading="loading"></loader>
          </v-container>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <charts :restaurant="restaurant" :dates="dates" :period="period"></charts>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="pa-0">
          <best-sellers :restaurant="restaurant" :period="period" :dates="dates"></best-sellers>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader'
import Charts from './clients/Charts'
import BestSellers from './clients/BestSellers'

export default {
  name: 'clients-reports',
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  components: { Loader, Charts, BestSellers },
  data () {
    return {
      loading: true,
      clients_reports: {
        avgTicket: 0,
        total: 0,
        discounts: 0
      }
    }
  },
  computed: {
    ...mapGetters(['restaurant'])
  },
  async mounted () {
    await this.getClientsReports()
  },
  methods: {
    async getClientsReports (dates = []) {
      let [ fromDate ] = dates
      this.loading = true
      try {
        const salesReport = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/total-sales`, {
          date: fromDate,
          type: this.period
        })
        this.clients_reports = salesReport || {}
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    }
  },
  watch: {
    dates: async function (value) {
      if (value.length >= 2) await this.getClientsReports(value)
    }
  }
}
</script>
